<template>
    <button @click="toggleNavigation">
        <transition name="navigationAnimation">    
            <img src="@/assets/img/ui/menu-close.png" v-if="navigationOpen">
            <img src="@/assets/img/ui/back.png" v-else-if="isSubpage">
            <img src="@/assets/img/ui/menu-open.png" v-else>
        </transition>
    </button>
</template>
<script>
export default {
    name: "NavigationButton",
    props: ["navigationOpen"],
    data() {
        return {
            isSubpage: false
        }
    },
    mounted() {
        this.checkIfSubpage(app.vm.$router.currentRoute._value.path)
    },
    methods: {
        toggleNavigation() {
            if(this.isSubpage) {
                let routeLength = this.$router.currentRoute.value.path.split("/").filter(el => el != '' || null).length;
                this.$router.go(2 - routeLength);
            } else {
                this.$emit('toggleNavigation')
            }
        },
        navigateBack() {

        },
        checkIfSubpage(path) {
            this.isSubpage = path.split("/").filter(el => el != '' || null).length > 2
        }
    },
    watch:{
        $route (to){
            this.checkIfSubpage(to.path)
        }
    } 
}
</script>
<style lang="scss" scoped>
    @import '@/assets/sass/_responsiveness.scss';

    button { 
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 100px;
        z-index: 2;
        color: #fff;
        cursor: pointer;

        > img {
            position: absolute;
        }

        @include tablet-down {
            height: 23px;
            width: 90px;
        }
    }
</style>